import { PricelistPeriodUpdatePage } from '@/features/pricelist-period/pages/PricelistPeriodUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/pricelist/period/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["pricelist.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PricelistPeriodUpdatePage,
})
